
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z","fill":"#ABABAB"}}),_c('path',{attrs:{"d":"M12.056 8.28c1.173 0 2.112.245 2.816.736.715.48 1.072 1.179 1.072 2.096 0 .928-.277 1.637-.832 2.128-.544.48-1.275.768-2.192.864l-.112 1.504h-1.952l-.096-2.416c1.013-.107 1.739-.299 2.176-.576.437-.288.656-.683.656-1.184 0-.416-.144-.736-.432-.96-.277-.235-.693-.352-1.248-.352s-1.008.16-1.36.48c-.341.31-.533.752-.576 1.328l-2.08-.864a3.009 3.009 0 011.248-2.032c.704-.501 1.675-.752 2.912-.752zm-.224 8.368c.427 0 .763.112 1.008.336.245.224.368.528.368.912s-.123.688-.368.912c-.245.224-.581.336-1.008.336-.427 0-.763-.112-1.008-.336-.235-.224-.352-.528-.352-.912s.117-.688.352-.912c.245-.224.581-.336 1.008-.336z","fill":"#fff"}})])
          )
        }
      }
    